import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Field, Section, ghostButton, inputClass, primaryButton } from "@/components/settings/primitives";
import { ChangePasswordForm } from "@/components/settings/ChangePasswordForm";
import { useAuth } from "@/context/AuthContext";
import { useUpdateProfile } from "@/hooks/queries";

export function AccountSection({ me }) {
  const [name, setName] = useState(me.profile?.display_name || "");
  const update = useUpdateProfile();
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const dirty = name.trim() && name.trim() !== me.profile?.display_name;

  const save = async (e) => {
    e.preventDefault();
    try {
      await update.mutateAsync(name.trim());
      toast.success("Profile updated");
    } catch (err) {
      toast.error(err.message || "Couldn't update your profile");
    }
  };

  return (
    <div className="space-y-4">
      <Section title="Profile" description="How ChatSleek addresses you." testId="settings-profile-section">
        <form onSubmit={save} className="space-y-4">
          <Field label="Display name">
            <input value={name} onChange={(e) => setName(e.target.value)} maxLength={80} className={inputClass} data-testid="settings-display-name-input" />
          </Field>
          <Field label="Email" hint="Your sign-in email can't be changed yet.">
            <input value={me.email} disabled className={inputClass} data-testid="settings-email-input" />
          </Field>
          <button type="submit" disabled={!dirty || update.isPending} className={primaryButton} data-testid="settings-save-profile-button">
            {update.isPending ? "Saving…" : "Save changes"}
          </button>
        </form>
      </Section>
      <Section title="Password" description="Change the password you use to sign in." testId="settings-account-password-section">
        <ChangePasswordForm email={me.email} testIdPrefix="account-password" />
      </Section>
      <Section title="Log out" description="Sign out of ChatSleek on this device." testId="settings-logout-section">
        <button
          type="button"
          className={ghostButton}
          data-testid="settings-logout-button"
          onClick={async () => {
            await signOut();
            navigate("/sign-in", { replace: true });
          }}
        >
          Log out
        </button>
      </Section>
    </div>
  );
}
